//natives
import React from 'react';

import List from '@material-ui/core/List';
import ComunicadosHome from './childrens/comunicados/comunicados';
import Pendencias from './childrens/pendencias/pendencias' 
//css
import UnicoCss from './Unico-css';
const useStyles = UnicoCss();

export default function (props) {
    const classes = useStyles();
    return (
        <List dense disablePadding  className={classes.root} subheader={<li />}>
            {props.props.message === "comunicado" &&  <ComunicadosHome {...props}/>}
            {props.props.message === "pendencias" &&  <Pendencias {...props}/>}
        </List>
    );
    
}